module.exports = __webpack_public_path__ + "img/xyzpc.fd5e3415.png";